var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 46.5,
    y: 0.5,
    width: 46,
    height: 46,
    rx: 22.75,
    transform: "rotate(90 46.5 0.5)",
    fill: "#EEFFF6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 46.5,
    y: 0.5,
    width: 46,
    height: 46,
    rx: 22.75,
    transform: "rotate(90 46.5 0.5)",
    stroke: "#EEFFF6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4462 25.1872L19.6676 24.008L22.6577 26.9982L22.6577 16.7643L24.3423 16.7643L24.3423 26.9982L27.3324 24.008L28.5538 25.1872L23.5 30.241L18.4462 25.1872Z",
    fill: "#007367"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame11);
export default __webpack_public_path__ + "static/media/frame-11.4bb7c8dc1f41fc9f4e797c13d3026857.svg";
export { ForwardRef as ReactComponent };